import Default from "components/layouts/Guest/Default";
import VerifyOtp from "components/templates/VerifyOtp/VerifyOtp";

const App = () => (
  <Default>
    <VerifyOtp />
  </Default>
);

export default App;
